import { render, staticRenderFns } from "./RoomChange.vue?vue&type=template&id=154cce24&scoped=true&"
import script from "./RoomChange.vue?vue&type=script&lang=js&"
export * from "./RoomChange.vue?vue&type=script&lang=js&"
import style0 from "./RoomChange.vue?vue&type=style&index=0&id=154cce24&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "154cce24",
  null
  
)

export default component.exports